<template>
  <div>
    <div class="query_wapper">
      <div class="query_item">
        <el-select
          :popper-append-to-body="false"
          placeholder="性别"
          style="width:200px"
          clearable
          v-model="query.gender"
        >
          <el-option label="全部" value="all"></el-option>
          <el-option label="男" :value="1"></el-option>
          <el-option label="女" :value="0"></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-select
          :popper-append-to-body="false"
          placeholder="按项目查询"
          style="width:200px"
          clearable
          v-model="query.project"
        >
          <el-option
            v-for="item in projectList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-input
          v-model="query.keyword"
          clearable
          placeholder="关键词搜索"
          style="width:390px"
          @keyup.enter.native="handleSearch"
        >
          <el-button class="search_btn" slot="append" @click="handleSearch">查询</el-button>
        </el-input>
      </div>
      <div class="query_item" style="margin-right:10px">
        <el-button
          style="width:90px;padding:12px 0;text-align:center"
          type="primary"
          @click="exportExcel"
        >导出EXCEL</el-button>
        <el-button style="width:90px;margin-left:20px;" type="warning" @click="print">打印</el-button>
      </div>
    </div>
    <div style="font-size:24px">{{schoolName}}注册教练员汇总表</div>
    <printTable
      :printTitle="schoolName + '注册教练员汇总表'"
      ref="print_table"
      :printColumns="printColumns"
      :printTableData="printTableData"
    ></printTable>
    <el-table border style="width:100%;margin-top:40px" :data="tableData">
      <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
      <el-table-column prop="name" align="center" label="姓名" min-width="100"></el-table-column>
      <el-table-column label="出生年月" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{formatTime(scope.row.birthday,'slash')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="gender" align="center" label="性别" min-width="60">
        <template slot-scope="scope">
          <span>{{!scope.row.gender?'女':'男'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="schoolName" align="center" label="学校名称" min-width="100"></el-table-column>
      <el-table-column align="center" label="职称">
        <template slot-scope="scope">
          <span>{{getPositional(scope.row.positional)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="political" align="center" label="政治面貌">
        <template slot-scope="scope">
          <span>{{scope.row.political === 1?'团员':scope.row.political === 2?'党员':scope.row.political === 3?'民主党派':'群众'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="education" align="center" min-width="80" label="学历">
        <template slot-scope="{row}">
          <span>{{row.education === 1?'大专':row.education === 2?'本科':row.education === 3?'研究生':'其他'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="registerNumber" align="center" label="注册号" min-width="100"></el-table-column>
      <el-table-column align="center" label="注册项目" min-width="100">
        <template slot-scope="scope">
          <span>{{registProject(scope.row.projectFirst)}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="失效时间" min-width="100">
        <template slot-scope="scope">
          <span>{{formatTime(scope.row.trainingEndTime,'slash')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="phone" align="center" label="联系电话" min-width="100"></el-table-column>
    </el-table>
    <el-pagination
      style="text-align:center;margin:20px 0 0 0"
      :page-sizes="pageSizeList"
      :page-size="pageSize"
      @size-change="$event=>sizeChange($event,this.getList)"
      @current-change="$event=>numberChange($event,this.getList)"
      :current-page.sync="pageNo"
      background
      layout="prev, pager, next,sizes"
      :total="total"
    ></el-pagination>
  </div>
</template>
<script>
import printTable from "@/components/print-table";
import registerData from "@/assets/json/register.json";
import { page, table, message, formatPrintTableData } from "@/common/js/mixins";
import { getCoachList } from "@/api/coach";
import { method } from "@/utils/utils";
import { baseUrl } from "@/utils/config";
import { getSession } from "@/utils/storage";
export default {
  mixins: [page, table, message, formatPrintTableData],
  components: {
    printTable
  },
  data() {
    return {
      query: {
        gender: "",
        project: "",
        keyword: ""
      },
      printColumns:[
        {
          title:"序号",
          key:"index",
          width:50,
        },{
          title:"姓名",
          key:"name"
        },{
          title:"出生年月",
          key:"birthdayText",
          width:70,
        },{
          title:"性别",
          key:"genderText",
          width:50
        },{
          title:"学校名称",
          key:"schoolName"
        },{
          title:"职称",
          key:"positionalText"
        },{
          title:"政治面貌",
          key:"politicalText"
        },{
          title:"学历",
          key:"educationText",
          width:70,
        },{
          title:"注册号",
          key:"registerNumber"
        },{
          title:"注册项目",
          key:"projectFirst"
        },{
          title:"失效时间",
          key:"trainingEndTimeText",
          width:70
        },{
          title:"联系电话",
          key:"phone",
          width:100
        }
      ],
      schoolName: JSON.parse(getSession("userInfo")).schoolName || "",
      projectList: []
    };
  },
  computed: {
    // 获取职称筛选
    getPositional() {
      return data => {
        let str = "";
        switch (data) {
          case 1: {
            str = "初级职称";
            break;
          }
          case 2: {
            str = "中级职称";
            break;
          }
          case 3: {
            str = "副教授（高级教练）";
            break;
          }
          case 4: {
            str = "教授（国家级教练）";
            break;
          }
        }
        return str;
      };
    },
    // 筛选学制
    schoolSystem() {
      return data => {
        let label = "";
        registerData.educationalList.filter(item => {
          if (item.value === data) {
            label = item.label;
          }
        });
        return label;
      };
    },
    // 筛选组别
    getGroup() {
      return data => {
        let str = "";
        switch (data) {
          case 1: {
            str = "甲组（普通本科）";
            break;
          }
          case 2: {
            str = "乙组（高职高专）";
            break;
          }
          case 3: {
            str = "丁组（高水平）";
            break;
          }
          case 4: {
            str = "丙组（体育院系";
            break;
          }
          default:
            str = "";
            break;
        }
        return str;
      };
    },
    // 格式化时间
    formatTime() {
      return (data, type = null) => {
        return method.timeFormat(data, type);
      };
    },
    // 筛选注册项目
    registProject() {
      return data => {
        let label = "";
        this.projectList.filter(item => {
          if (item.value === data) label = item.label;
        });
        return label;
      };
    }
  },
  methods: {
    // 打印
    async print() {
      let { list } = await getCoachList({
        ...this.query,
        pageNo: 1,
        pageSize: 9999,
        gender: this.query.gender === "all" ? "" : this.query.gender
      });
      // 调用公共方法打印（方法在mixins.js)
      this.getPrintData(list);
    },
    // 获取项目
    getProjectList(value) {
      this.projectList = [
        ...registerData.sportsProjectList,
        ...registerData.sunshineProject
      ];
    },
    // 表格导出
    exportExcel() {
      let params = [];
      for (let k in this.query) {
        if (this.query[k] === 0) {
          params.push(k + "=" + this.query[k]);
        } else {
          params.push(k + "=" + (this.query[k] ? this.query[k] : ""));
        }
      }
      // params.push("pageNo=" + this.pageNo);
      // params.push("pageSize=" + this.pageSize);
      window.location.href =
        baseUrl + "/coach/downloadList?" + params.join("&");
    },
    // 查询
    handleSearch() {
      this.pageNo = 1;
      this.getList();
    },
    // 列表查询
    getList() {
      getCoachList({
        ...this.query,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        gender: this.query.gender === "all" ? "" : this.query.gender
      })
        .then(res => {
          this.total = res.total;
          this.tableData = res.list;
        })
        .catch(err => {});
    }
  },
  mounted() {
    this.getProjectList();
    this.getList();
  }
};
</script>
<style lang="less" scoped>
</style>